import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, CompanyService } from './_services';
import { BaseComponent } from './_components/base.component';

@Component({
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent extends BaseComponent {
  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
  ) {
    super(router, authenticationService, companyService);
    if (this.authenticationService.isSessionValid()) {
      this.router.navigate(['/dashboard']);
    } else if (this.authenticationService.id()) {
      this.authenticationService.logout(true);
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
